/**
 * Backbone based dropdown that allows to create list of emails and phones
 * Includes validation and highlights invalid emails and phones.
 */
var CRecipientDropdown = Backbone.View.extend({

    tagName: 'select',

    className: 'recipients-dropdown form-control',

    initialize: function( options )
    {
        this.storedRecipients = [];
        if ( options && options.storedRecipients )
        {
            this.storedRecipients = options.storedRecipients;
        }
        _.bindAll(this, 'isValidElement');
    },

    // Element needs to be assigned to DOM before render() is executed
    render: function(arrData)
    {
        if (!$('.recipients-dropdown').length) {
            throw new Error('RecipientDropdown: Element(el) is not rendered to DOM yet');
        }

        arrData = _.uniq(_.union( arrData, this.storedRecipients ));
        this.$el.select2({
            width: '100%',
            multiple: true,
            tags: true,
            placeholder: 'Write email/phone and press ENTER',
            data: arrData
        });
        this.bindEvents();
        return this;
    },

    setValue: function( arrValues )
    {
        this.$el.select2('val', arrValues);
    },

    getValue: function()
    {
        return this.$el.select2('val');
    },

    bindEvents: function()
    {
        var self = this;

        this.$el.off("select2:select").on("select2:select", function ( event ) {
            self.validateItems();
        });
        this.$el.off("select2:unselect").on("select2:unselect", function ( event ) {
            self.validateItems();
        });
    },

    validateItems: function()
    {
        var self = this;

        this.$el.data('select2').$container.find('.select2-selection__choice').each(function () {
            var strValue = $(this).attr('title');
            if (!self.isEmail( strValue ) && !self.isPhoneNumber( strValue ))
            {
                $(this).addClass('invalid');
            }
        });
    },

    isValid: function()
    {
        if (!this.$el.select2('val'))
        {
            return false; //empty
        }
        return this.$el.select2('val').every(this.isValidElement);
    },

    isValidElement: function( strElement )
    {
        return (this.isEmail(strElement) || this.isPhoneNumber(strElement));
    },

    isEmail: function( strEmail )
    {
        var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
        return re.test(strEmail);
    },

    isPhoneNumber: function( strMobile )
    {
        var re = /^[0-9]+$/i;
        return re.test(strMobile);
    }
});
